import React, { useState } from 'react';
import { LegalModal, LegalType } from './LegalModal';
export function Footer() {
  const [openModal, setOpenModal] = useState<LegalType | null>(null);
  return <>
      <footer className="py-10 pb-32 md:pb-10 px-4 bg-[#0a0a0a] border-t border-[#2a2a2a] text-center" data-id="element-49">
        <div className="max-w-4xl mx-auto space-y-4" data-id="element-50">
          <p className="text-[#C9A84C] font-serif font-bold tracking-widest text-sm uppercase" data-id="element-51">
            El Azúcar Silencioso
          </p>

          <p className="text-sm text-[#666] max-w-2xl mx-auto" data-id="element-52">
            Solo con fines educativos. Este producto no brinda consejo médico,
            diagnóstico ni tratamiento.
          </p>
          <p className="text-sm text-[#666]" data-id="element-53">
            Producto digital. Todas las ventas son finales. Revisa tu correo
            después de la compra para el enlace de descarga.
          </p>

          <div className="flex items-center justify-center gap-6 pt-2" data-id="element-54">
            <button onClick={() => setOpenModal('privacy')} className="text-sm text-[#aaa] hover:text-[#C9A84C] transition-colors duration-200 underline underline-offset-4 decoration-[#555] hover:decoration-[#C9A84C]" data-id="element-55">
              Política de Privacidad
            </button>
            <span className="text-[#555]" data-id="element-56">|</span>
            <button onClick={() => setOpenModal('terms')} className="text-sm text-[#aaa] hover:text-[#C9A84C] transition-colors duration-200 underline underline-offset-4 decoration-[#555] hover:decoration-[#C9A84C]" data-id="element-57">
              Términos de Uso
            </button>
          </div>

          <div className="pt-3 text-xs text-[#555]" data-id="element-58">
            © 2025 El Azúcar Silencioso. Todos los derechos reservados.
          </div>
        </div>
      </footer>

      {openModal && <LegalModal type={openModal} onClose={() => setOpenModal(null)} data-id="element-59" />}
    </>;
}